export default '7FEE6';
